import React from "react";
import { Table as AntTable } from "antd";
import styled from "@emotion/styled";
import COLORS from "common/Colors";

export const StyledTable = styled(AntTable)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
    /* border-radius: 10px; */
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    /* border-radius: 10px; */
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-select-selector {
    min-width: 150px;
  }
`;

const Table = (props) => {
  return <StyledTable {...props} />;
};

export default Table;
